// Client for Data Lifecycle (/api/lifecycle): archive, restore and delete whole data types.
import React, { useEffect, useState } from "react";
import { AlertOctagon, RotateCcw, Loader2 } from "lucide-react";
import { headers, parse } from "./classificationApi";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/lifecycle`;
const get = (p) => fetch(`${BASE}${p}`, { headers: headers(null, false) }).then(parse);
const post = (p, body) => fetch(`${BASE}${p}`, { method: "POST", headers: headers(null, true), body: JSON.stringify(body || {}) }).then(parse);

export const getLifecycle = () => get("");
export const getAlert = () => get("/alert");
export const getHistory = () => get("/history");
export const getPreview = (kind) => get(`/${kind}/preview`);
export const archiveKind = (kind, confirm, reason) => post(`/${kind}/archive`, { confirm, reason });
export const restoreKind = (kind, reason) => post(`/${kind}/restore`, { reason });
export const deleteKind = (kind, confirm, reason) => post(`/${kind}/delete`, { confirm, reason });
export const setTraining = (use) => post("/training", { use });
export const getClearPreview = () => get("/clear/preview");
export const clearBronzeSilver = (confirm, reason) => post("/clear", { confirm, reason });

// Red banner shown when synthetic is archived and actual data fails to load (Data Lifecycle, Live Data Pipeline, Morning Brief).
export function LifecycleAlert({ isItHead, onRestored, alert: given }) {
  const [alert, setAlert] = useState(given || null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);
  useEffect(() => {
    if (given !== undefined) { setAlert(given); return; }
    getAlert().then(r => setAlert(r.alert)).catch(() => setAlert(null));
  }, [given]);
  if (!alert) return null;
  const restore = async () => {
    setBusy(true); setErr(null);
    try { await restoreKind("synthetic", "Restore Synthetic from the failure alert"); setAlert(null); onRestored && onRestored(); }
    catch (e) { setErr(e.message); } finally { setBusy(false); }
  };
  return (
    <div data-testid="lifecycle-alert" role="alert" className="tile border-critical/60 bg-critical/10 px-4 py-3 flex flex-wrap items-center gap-3">
      <AlertOctagon size={18} className="text-critical shrink-0" />
      <div className="min-w-0 flex-1">
        <div className="text-sm font-semibold text-critical" data-testid="lifecycle-alert-message">{alert.message}</div>
        <div className="text-[12px] text-fg/80" data-testid="lifecycle-alert-reason">{alert.reason}</div>
        {err && <div className="text-[12px] text-critical mt-1">{err}</div>}
      </div>
      {isItHead && (
        <button data-testid="lifecycle-alert-restore" onClick={restore} disabled={busy}
                className="inline-flex items-center gap-1.5 h-9 px-3.5 rounded-sm bg-critical text-white text-[12.5px] font-medium hover:opacity-90 disabled:opacity-60">
          {busy ? <Loader2 size={13} className="animate-spin" /> : <RotateCcw size={13} />}Restore Synthetic
        </button>
      )}
    </div>
  );
}
